module.exports = __webpack_public_path__ + "static/img/02002A_10_11_12_R_20200611_LC.9ad8d05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02002A_10_11_12_R_20200611_LC.png
// module id = NPlN
// module chunks = 0